import axios from "axios";
import { defaultValue, ICode } from "../shared/model/code.model";
import { FAILURE, REQUEST, SUCCESS } from "./actionType.util";

// TYPES
export const ACTION_TYPES = {
  FETCH_CODE: "CODE/FETCH_CODE",
  CREATE_CODE: "CODE/CREATE_CODE",
  RESET: "CODE/RESET",
};

const initialState = {
  loading: false,
  errorMessage: null,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type CodeState = Readonly<typeof initialState>;

// RECUCER

export const codeReducer = (state: CodeState = initialState, action: any) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CODE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CODE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.CREATE_CODE):
    case FAILURE(ACTION_TYPES.FETCH_CODE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };

    case SUCCESS(ACTION_TYPES.FETCH_CODE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CODE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        // entity: action.payload.data,
        entity: { ...state.entity, ...action.payload.data },
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

// ACTIONS
const apiUrl = "/api/ksds/portal-external";
export const validateCandidate = (doc: string, appId: string) => {
  const requestUrl = `${apiUrl}/candidates/?document=${doc}&applicationId=${appId}`;
  return {
    type: ACTION_TYPES.FETCH_CODE,
    payload: axios.get<ICode>(requestUrl),
  };
};

export const createCode = (candidateId) => {
  const requestUrl = `${apiUrl}/mail/send-code`;
  return {
    type: ACTION_TYPES.CREATE_CODE,
    // payload: { status_code: 200, message: "OK" },
    payload: axios.post(requestUrl, candidateId),
  };
};
export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
